import { IUserNotificationModel } from 'shared/models';
import { makeQuery } from 'shared/utilities';

type ResponseType = {
    item: IUserNotificationModel;
};

export const userNotificationsGetQuery = async function () {
    return await makeQuery<ResponseType>('/user-notifications/get');
}
